import { render, staticRenderFns } from "./TagSearchFilter.vue?vue&type=template&id=f1019744"
import script from "./TagSearchFilter.vue?vue&type=script&lang=ts"
export * from "./TagSearchFilter.vue?vue&type=script&lang=ts"
import style0 from "./TagSearchFilter.vue?vue&type=style&index=0&id=f1019744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports